import ReactDomServer from 'react-dom/server'
import React from 'react'

let staticData = {
  MaxxiaData: {
    TestimonialData: [
      {
        imageName: 'UserTestimonial1',
        headingText:
          'Cindy Wall, Government of Western Australia - Department of communities',
        bodyText:
          '“I recently took out a novated lease on a pre-existing car… and was hugely surprised at the speed and smoothness of the process from start to beginning.”',
      },
      {
        imageName: 'UserTestimonial2',
        headingText: 'JUSTIN LANG, INDUSTRIES SA',
        bodyText:
          '“I like having all the running costs bundled and the tax minimisation available.”',
      },
      {
        imageName: 'UserTestimonial3',
        headingText:
          ' David Graham, Department of disability – housing & community services',
        bodyText:
          '“Being able to spread vehicle running costs over the year – and having them covered for when they’re due – was why I chose it over regular car finance.”',
      },
    ],
    WhatsNLText:
      'Novated leasing is a tax-effective way to drive the car you’ve got your eye on. Basically, a new, used or existing car is leased in your name, via your employer. Instead of making your car repayments and running costs (think rego, petrol and servicing) with the money you have left over after tax, your lease is covered using a combination of your pre and post-tax salary. This could lower your taxable income and boost your savings while saving you a whole lot of life admin (think of the time it takes to negotiate a car deal or organise car services).',
    EstimateReviewBannerText:
      'The estimate you asked #consultantFirstName# to put together is ready and waiting for you. Still haven’t wrapped your head around what novated leasing actually is? Don’t glaze over. Get up to speed with our quick recap below.',
    EstimateReviewReleaseBannerText:
      'The estimate you asked #consultantFirstName# to put together is ready and waiting for you. Also, as your lease is coming to an end, we’ve summarised your current expiring lease amount below and recapped the key benefits of leasing with #brand#.',
    EstimateReviewSpartaBannerText:
      'The estimate you asked #consultantFirstName# to put together is ready and waiting for you. Remember, some of the cars you discussed with #consultantFirstName# may have limited availability. You have to proceed as soon as possible to increase your chances of getting it.',
    EstimateAcceptedBannerText:
      '#consultantFirstName# will be in touch soon to guide you through what comes next. In the meantime start planning that roadtrip you’ve been waiting for!',
    EstimateAcceptedFinAppBannerText:
      "Please click on 'Start finance application' to complete your Finance application for #consultantFirstName# to start working on your proposal and to get quick financier approval.",
    ProposalReviewBannerText:
      "Hi #firstName#, #consultantFirstName#'s uploaded the final details of your lease in your proposal. Take a moment to check it over and give it your tick of approval.#isSparta# Once you do, we can start getting the #vehicleDescription# ready for you.",
    NextStepNoneBannerTitleText:
      'Don’t forget to complete your lease paperwork #firstName# – if you have already, the team will touch base shortly.',
    NextStepNoneBannerText:
      "You have completed what's required here, however if you haven't done so already, please check your email for all the documents which are required to be signed and returned to get you behind the wheel of the #vehicleDescription#.",
    NextStepATOBannerText:
      'Hi #firstName#, please check and accept your Authority to Order. Once you do, we can start getting the #vehicleDescription# ready for you.',
    NextStepInsConBannerText:
      'You have completed what’s required here, however if you haven’t done so already, please check your email for all the documents which are required to be signed and returned to get you behind the wheel of the #vehicleDescription#.',
    NextStepDeferredBannerText: (
      <>
        If you have included add-on insurances in your lease, we will send you a
        separate link to confirm the purchase of these through our online portal
        or you can check back here.
        <br />
        <br />
        Don't worry if you don't see this straight away as we are required to
        send you this link at a later date after you have time to consider if
        these insurances are right for you.
      </>
    ),
    SettlementBannerText: (
      <>
        Your final step to get behind the wheel of your new #vehicleDescription#
        is to sign your lease documents. Please click on 'Sign my documents' to
        go to the paperwork page to be directed to Adobe Sign, where you can
        easily sign them electronically by following a few simple steps.
        <br />
        Once you are done, we will organize for your employer to sign the
        documents and have everything ready to finalise your lease.
        <br />
        <strong>
          If you have organised your own comprehensive insurance, kindly
          remember to send our team a copy of your Certificate of Insurance if
          you haven’t already.
        </strong>
      </>
    ),
  },
  RemServData: {
    TestimonialData: [
      {
        imageName: 'UserTestimonial1',
        headingText: 'Lisa, Customer, ' + global.config.brand,
        bodyText:
          '“RemServ just did everything. They were so helpful, I thought yes, let’s go for it! I don’t have to worry about petrol, about the tyres need replacing, or that it’s up for a service. All that’s been taken out of my pay and I just love it.”',
      },
      {
        imageName: 'UserTestimonial2',
        headingText: 'Ester, Customer, ' + global.config.brand,
        bodyText:
          '“A novated lease just makes financial sense… It’s enabled me to take the kids on holidays and treat them.”',
      },
    ],
    WhatsNLText:
      'Novated leasing could be a tax-effective way to drive the car you’ve got your eye on. And it doesn’t need to be a new car, you can even take a novated lease on a used car, or even your existing vehicle, so long as it meets the age requirements. Basically, a new, used or existing car is leased in your name, via your employer. Instead of making your car repayments with the money you have left over after tax, your lease and the running costs you select such as fuel, services and comprehensive insurance are paid for using a combination of your pre and post-tax salary, in a regular payment taken from your salary each pay day. This could lower your taxable income, while also saving you on life admin and bill shock.',
    EstimateReviewBannerText:
      'The estimate you asked #consultantFirstName# to put together is ready and waiting for you. Still haven’t wrapped your head around what novated leasing actually is? Don’t glaze over. Get up to speed with our quick recap below.',
    EstimateReviewReleaseBannerText:
      'The estimate you asked #consultantFirstName# to put together is ready and waiting for you. Also, as your lease is coming to an end, we’ve summarised your current expiring lease amount below and recapped the key benefits of leasing with #brand#.',
    EstimateReviewSpartaBannerText:
      'The estimate you asked #consultantFirstName# to put together is ready and waiting for you. Remember, some of the cars you discussed with #consultantFirstName# may have limited availability. You have to proceed as soon as possible to increase your chances of getting it.',
    EstimateAcceptedBannerText:
      '#consultantFirstName# will be in touch soon to guide you through what comes next. In the meantime start planning that roadtrip you’ve been waiting for!',
    EstimateAcceptedFinAppBannerText:
      "Please click on 'Start finance application' to complete your Finance application for #consultantFirstName# to start working on your proposal and to get quick financier approval.",
    ProposalReviewBannerText:
      "Hi #firstName#, #consultantFirstName#'s uploaded the final details of your lease in your proposal. Take a moment to check it over and give it your tick of approval.#isSparta# Once you do, we can start getting the #vehicleDescription# ready for you.",
    NextStepNoneBannerTitleText:
      'Don’t forget to complete your lease paperwork #firstName# – if you have already, the team will touch base shortly.',
    NextStepNoneBannerText:
      "You have completed what's required here, however if you haven't done so already, please check your email for all the documents which are required to be signed and returned to get you behind the wheel of the #vehicleDescription#.",
    NextStepATOBannerText:
      'Hi #firstName#, please check and accept your Authority to Order. Once you do, we can start getting the #vehicleDescription# ready for you.',
    NextStepInsConBannerText:
      'You have completed what’s required here, however if you haven’t done so already, please check your email for all the documents which are required to be signed and returned to get you behind the wheel of the #vehicleDescription#.',
    NextStepDeferredBannerText: (
      <>
        If you have included add-on insurances in your lease, we will send you a
        separate link to confirm the purchase of these through our online portal
        or you can check back here.
        <br />
        <br />
        Don't worry if you don't see this straight away as we are required to
        send you this link at a later date after you have time to consider if
        these insurances are right for you.
      </>
    ),
    SettlementBannerText: (
      <>
        Your final step to get behind the wheel of your new #vehicleDescription#
        is to sign your lease documents. Please click on 'Sign my documents' to
        go to the paperwork page to be directed to Adobe Sign, where you can
        easily sign them electronically by following a few simple steps.
        <br />
        Once you are done, we will organize for your employer to sign the
        documents and have everything ready to finalise your lease.
        <br />
        <strong>
          If you have organised your own comprehensive insurance, kindly
          remember to send our team a copy of your Certificate of Insurance if
          you haven’t already.
        </strong>
      </>
    ),
  },
}

const elementHolderReplace = (args, content) => {
  let stringContent = ReactDomServer.renderToString(content)
  stringContent = stringHolderReplace(args, stringContent)

  return <div dangerouslySetInnerHTML={{ __html: stringContent }} />
}

const stringHolderReplace = (args, content) => {
  let stringContent = content
  let keys = Object.keys(args)
  keys.forEach((arg) => {
    stringContent = stringContent.replace(
      new RegExp(`#${arg}#`, 'g'),
      args[arg]
    )
  })
  return stringContent
}

export const HomeStaticData = (prop, args) => {
  let data
  if (global.config.isBrandMX) data = staticData.MaxxiaData
  else if (global.config.isBrandRS) data = staticData.RemServData

  let content = data[prop]
  if (args) {
    if (React.isValidElement(content)) {
      content = elementHolderReplace(args, content)
    }
    if (typeof content == 'string') {
      content = stringHolderReplace(args, content)
    }
  }
  return content
}
